import React from "react";
import { Modal } from "react-bootstrap";
import { ReactComponent as ConfirmIcon } from "assets/images/big-tik.svg";
import Button from "../Button";
import { ConfirmModalProps } from "./ConfirmModal.props";

const ConfirmModal = React.memo<ConfirmModalProps>(
    ({
        modalText,
        confirmFunc,
        setShowModal,
        showModal,
        showCloseBtn,
        modalBtnText,
        headerComponent,
        modalIcon,
        customModalBody,
        confirmOnHide,
    }) => {
        return (
            <Modal
                show={showModal}
                onHide={() => {
                    setShowModal(false);
                    confirmOnHide && confirmFunc();
                }}
                className="rtl confirm-submit-order"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                data-testid="ConfirmModal"
            >
                {showCloseBtn && (
                    <Modal.Header
                        closeButton
                        className="border-bottom-0"
                        data-testid="ConfirmModal__closeButton"
                    >
                        {headerComponent}
                    </Modal.Header>
                )}

                <Modal.Body className={customModalBody}>
                    {modalIcon ? (
                        modalIcon
                    ) : (
                        <ConfirmIcon className="confirm-logo" />
                    )}

                    {modalText}
                </Modal.Body>
                <Button
                    btnText={modalBtnText || "تایید"}
                    className="solid is-green"
                    handleClick={confirmFunc}
                />
            </Modal>
        );
    }
);

export default ConfirmModal;
